/*============================================================================*/

/**
 * Local data management
 *
 * Functions to read, write, and manage client-side storage, 
 * including cookies and localStorage.
 */

/*============================================================================*/


/**
 * Deletes all cookies for the current domain.
 */
function clearAllCookies()
{
    document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Lax`;
    });
}

/**
 * Clears both sessionStorage and localStorage in the browser.
 */
function clearWebStorage()
{
    sessionStorage.clear();
    localStorage.clear();
}

/**
 * Clears all user session data, including cookies and web storage.
 * Effectively resets the user's local session state.
 */
function clearUserSessionData()
{
    clearAllCookies();
    clearWebStorage();
}

/**
* Define a cookie
*
* Sets a cookie with the given name and value, available throughout the site.
*
* @param {string} name - Cookie name
* @param {string} value - Cookie value
* @param {number} [days=365] - Expiration time in days
*/
function setCookie(name, value, days = 365)
{
    const maxAge = 60 * 60 * 24 * days
    document.cookie = `${name}=${value}; path=/; max-age=${maxAge}`
}

/**
* Retrieve a cookie value
*
* Returns the cookie value for a given name, or null if it does not exist.
*
* @param {string} name - Cookie name
* @returns {string|null} Cookie value
*/
function getCookie(name)
{
    const cookies = document.cookie.split('; ')
    for (const cookie of cookies)
    {
        const [cookieName, cookieValue] = cookie.split('=')
        if (cookieName === name)
        {
            return cookieValue
        }
    }
    return null
}